import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd0db548"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "culture-container" }
const _hoisted_2 = { class: "top-container" }
const _hoisted_3 = { class: "top-block" }
const _hoisted_4 = {
  "data-wow-duration": "1s",
  class: "cultitle animate__animated animate__fadeInDown wow"
}
const _hoisted_5 = { class: "bottom-block" }
const _hoisted_6 = { class: "btm-left animate__backInLeft wow" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "btm-right" }
const _hoisted_11 = {
  class: "animate__backInRight wow",
  alt: ""
}

import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'ComCulture',
  setup(__props) {

onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})


return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('missioncontent')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('visionTitle')), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('vision')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('missionTitle')), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('mission1')), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('mission2')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('RCII')), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('RCII1')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
            [_directive_lazy, require('@/assets/about-culture.png')]
          ])
        ])
      ])
    ])
  ]))
}
}

})